import React, { Component } from "react";
import TransferCuentasTercerosService from "../../../../services/transferencias/TransferCuentasTercerosService";
import ConfirmarOperacionTransfer from "../ConfirmarOperacionTransfer";
import { trackPromise } from "react-promise-tracker";
import Popup from "react-popup";
import { splitImporte } from "../../../generico/utils/FormatoInput";
import { MENSAJE } from "../../../generico/utils/Constantes";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowRight, faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import { ModalPinTransaccional } from "../../../generico/ModalPinTransaccional";

export default class TransferCuentasTerceros extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  confirmarTransferencia = (titulo, mensaje, callback) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "No",
            className: "",
            action: function () {
              Popup.close();
            },
          },
          {
            text: "Sí",
            className: "success",
            action: function () {
              callback();
              Popup.close();
            },
          },
        ],
      },
    });

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  getInitialState = () => ({});

  resetState = () => {
    this.setState(this.getInitialState());
    //this.setState({ });
  };

  componentDidMount() {
    this.initData();
  }
  initData = () => {
    this.resetState();
    this.btn = undefined;
  };

  transferir(transferenciaDatosRepetidos) {
    return TransferCuentasTercerosService.transferir(
      this.props.cuentaOrigen,
      this.props.cuentaDestino,
      splitImporte(this.props.importe),
      transferenciaDatosRepetidos
    );
  }

  precondTrasnferir() {
    if (this.state.cuentaDebito === "") {
      Popup.queue(this.notifiPopup("Info", "Debe cargar la cuenta de Débito"));
      return false;
    }
    if (this.state.cuentaCredito === "") {
      Popup.queue(this.notifiPopup("Info", "Debe cargar la cuenta de Crédito"));
      return false;
    }
    if (this.state.cuentaDebito === this.state.cuentaCredito) {
      Popup.queue(
        this.notifiPopup(
          "Info",
          "Las cuentas de Débito y crédito no pueden ser las mismas"
        )
      );

      return false;
    }
    return true;
  }

  confirmarBtn = (e, transferenciaDatosRepetidos = false) => {
    //// bloquea boton

    //console.log("holaaaaaa")
    this.btn.setAttribute("disabled", "disabled");
    trackPromise(
      this.transferir(transferenciaDatosRepetidos).then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);

        if (jData.codigoRetorno === "0") {
          this.props.returnDataPaso2(jData.numeroOperacion);
          this.nextStep.click();
          this.btn.removeAttribute("disabled");
        } else if (jData.codigoRetorno === "-1") {
          this.btn.removeAttribute("disabled");
          Popup.queue(this.confirmarTransferencia("Atención", MENSAJE.CONFIRMAR_TRANSFERENCIA, () => { this.confirmarBtn(null, true) }))
        } else {
          //// Habilita boton
          this.btn.removeAttribute("disabled");
          Popup.queue(this.notifiPopup("Info", jData.mensajeRetorno));
        }
      })
        .catch(function (error) {
          console.log(error);
          //// Habilita boton
          this.btn.removeAttribute("disabled");
        })
    )
  };

  render() {
    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Cuentas
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Código de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>

              <li role="tab" className="disabled last">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="container-fluid">
        {this.props.cuentaOrigenSelected !== undefined && (
          <ConfirmarOperacionTransfer
            items={this.props.itemsConfirm}
            detalleCuentaBox={this.props.detalleCuenta}
            tipoCuenta={this.props.cuentaOrigenSelected.descripcion}
            moneda={this.props.cuentaOrigenSelected.moneda}
            nroOperacion={""}
          />
        )}  
        </div>
        <div className="row">
          <div className="col-lg-7 col-md-6"></div>
          <div className="col-lg-2 col-md-3 btn-consulta">
          <button
            onClick={ () => {this.props.goToStep(1);} }
            type="button"
            className="btn btn-cu-quintary"
          >
          <FontAwesomeIcon icon={faArrowLeft} />  Volver
          </button>
          </div>
          <div className="col-lg-3 col-md-3">
          <button 
            data-toggle="modal"
            data-target="#modal-terceros"
            ref={btn => { this.btn = btn; }}
            disabled={this.state.disableSgte}
            className="btn btn-cu-primary"
            // onClick={this.confirmarBtn}
          >
            Confirmar Transferencia <FontAwesomeIcon icon={faArrowRight} />
          </button>
          <ModalPinTransaccional id="modal-terceros" onSuccess={()=>this.confirmarBtn()} />
          <button
            hidden
            ref={(a) => (this.nextStep = a)}
            className="btn btn-cu-primary"
            onClick={this.props.nextStep}
          ></button>
          <button
            hidden
            ref={(a) => (this.previousStep = a)}
            className="btn btn-cu-primary"
            onClick={this.props.previousStep}
          ></button>
          </div>
        </div>
      </div>
    );
  }
}
